import React, { useEffect, useRef, useState } from 'react';
import { bool, string, node, func } from 'prop-types';
import classnames from 'classnames/bind';

import styles from './SubSection.scss';
const cx = classnames.bind(styles);

function SubSection({
  name,
  icon,
  heading,
  description,
  link,
  linkText,
  renderChildren,
  showSectionHeading,
  className,
  inView,
}) {
  const sectionRef = useRef(null);
  const observer = useRef(null);
  const [isInView, setIsInView] = useState(false);

  useEffect(() => {
    if (observer.current) observer.current.disconnect();
    observer.current = new IntersectionObserver(([entry]) => {
      if (!entry.isIntersecting && isInView) {
        return setIsInView(false);
      }

      if (entry.isIntersecting) {
        if (isInView) return;
        inView(name);
        setIsInView(true);
      }
    });
    const { current: currentObserver } = observer;
    if (sectionRef.current) currentObserver.observe(sectionRef.current);
    return () => currentObserver.disconnect();
  }, [inView, isInView, name, sectionRef]);

  const showLink = !!link && link !== '-';

  return (
    <section ref={sectionRef} id={name} className={cx(styles.root, className)}>
      {showSectionHeading && (
        <div className={styles.header}>
          {icon && (
            <img
              className={styles.icon}
              src={icon}
              width={120}
              height={120}
              aria-hidden
            />
          )}
          <div className={styles.headerContent}>
            <h2 className={styles.heading}>{heading}</h2>
            <p className={styles.description}>{description}</p>
            {showLink && (
              <a href={link} className={styles.link}>
                {linkText}
              </a>
            )}
          </div>
        </div>
      )}
      <div className={styles.body}>{renderChildren()}</div>
    </section>
  );
}

SubSection.propTypes = {
  heading: string.isRequired,
  inView: func.isRequired,
  name: string.isRequired,
  className: string,
  description: string,
  icon: node,
  link: string,
  linkText: string,
  renderChildren: func,
  showSectionHeading: bool,
};

SubSection.defaultProps = {
  renderChildren: () => {},
  className: null,
  showSectionHeading: true,
  description: null,
  icon: null,
  link: null,
  linkText: null,
};

export default SubSection;



// WEBPACK FOOTER //
// ./app/containers/Premium/components/SubSection/SubSection.jsx